import {
  PRODUCT_VARIANT_FIND_BY_UPC_LOADED,
  PRODUCT_VARIANT_BARCODE_SCAN_UNLOAD
} from 'redux/actions/productVariant/action_types';

const initialStore = {
  isLoaded: false,
  productVariant: null,
  error: null
};

const loaded = (state, payload) =>
  Object.assign({}, state, {
    isLoaded: true,
    productVariant: payload,
    error: payload ? null : 'Product variant not found'
  });

export default function barcodeScan(state = initialStore, action) {
  switch (action.type) {
    case PRODUCT_VARIANT_FIND_BY_UPC_LOADED:
      return loaded(state, action.payload);
    case PRODUCT_VARIANT_BARCODE_SCAN_UNLOAD:
      return Object.assign({}, initialStore);
    default:
      return state;
  }
}
